/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ProductionMode {
  Automation = 'Automation',
  Manual = 'Manual'
}
